var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from '../../services/search.service';
import { SEARCH_TYPES } from './search.component';
var SearchResultComponent = (function () {
    function SearchResultComponent(_service, router, route) {
        this._service = _service;
        this.router = router;
        this.route = route;
    }
    SearchResultComponent.prototype.ngOnInit = function () {
        var _this = this;
        //console.log("SEARCH INIT");
        //this._subscription = SearchComponent.observable().subscribe(item => this.searchAction(item));
        this.route.queryParams.subscribe(function (param) {
            //console.log("on subcribe");
            var filter = JSON.parse(atob(param["q"]));
            _this.searchAction(filter);
        });
    };
    SearchResultComponent.prototype.searchAction = function (filter) {
        var _this = this;
        //console.log("search@html: " + JSON.stringify(filter));
        this.filter = filter;
        switch (this.filter.id) {
            case SEARCH_TYPES.DESPACHO.id:
                this._service.findDespachos(this.filter.query).subscribe(function (response) {
                    _this.results = response;
                });
                break;
            case SEARCH_TYPES.EXPEDIENTE.id:
                this._service.findExpedientes(this.filter.query, 0).subscribe(function (response) {
                    _this.results = response;
                    _this.dataShowing = _this.results.data;
                    _this.showing = _this.dataShowing.length;
                });
                break;
            case SEARCH_TYPES.CEDULA.id:
                this._service.findCedulas(this.filter.query).subscribe(function (response) {
                    _this.results = response;
                });
                break;
            case SEARCH_TYPES.USUARIO.id:
                //console.log("search usuario");
                this._service.findUsuario(this.filter.query).subscribe(function (response) {
                    _this.results = response;
                    _this.dataShowing = _this.results.data;
                    _this.showing = _this.dataShowing.length;
                });
                break;
        }
    };
    SearchResultComponent.prototype.cargarMas = function () {
        var _this = this;
        this._service.findExpedientes(this.filter.query, this.results.page + 1).subscribe(function (response) {
            _this.results = response;
            _this.results.data.forEach(function (element) {
                _this.dataShowing.push(element);
            });
            _this.showing = _this.dataShowing.length;
            //console.log(this.dataShowing);
        });
    };
    return SearchResultComponent;
}());
SearchResultComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'search-result',
        templateUrl: 'search-result.component.html'
    }),
    __metadata("design:paramtypes", [SearchService, Router, ActivatedRoute])
], SearchResultComponent);
export { SearchResultComponent };
//# sourceMappingURL=search-result.component.js.map